/**
 * @file   : ADateText.js
 * @author :  ()
 * @date   : 6/5/2019, 4:16:28 PM
 */
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import {
  createDateFromMMDDYYYY,
  createMMDDYYYYFromYYYYMMDD,
  createYYYYMMDDFromDate,
} from '../../../utilities/DateUtils'
import { isUndefined } from '../../../utilities/GeneralUtils'
import { isValidDateLiteral } from '../../../utilities/ValidationUtils'
import AInput from '../AInput'

class ADateText extends Component {
  constructor(props) {
    super(props)
    let formattedValue = ''
    if (props.value !== null) {
      formattedValue = this.convertFromDateToMMDDYYYY(props.value)
    }
    this.state = { formattedValue }

    this.lastInput = formattedValue
  }

  componentDidUpdate(prevProps) {
    const { value } = this.props

    if (isUndefined(value) || +prevProps.value === +value) return

    let formattedValue = ''
    if (value !== null) {
      formattedValue = this.convertFromDateToMMDDYYYY(value)
    }

    this.setState({
      formattedValue,
    })
  }

  convertFromDateToMMDDYYYY(date) {
    let fd = createYYYYMMDDFromDate(date)
    fd = createMMDDYYYYFromYYYYMMDD(fd, '-', '-')

    return fd
  }

  handleChange(inputvalue) {
    let formattedInputValue = inputvalue
    if (this.lastInput.length < inputvalue.length) {
      if (inputvalue.length === 2) {
        formattedInputValue += '-'
      } else if (inputvalue.length === 5) {
        formattedInputValue += '-'
      }
    }

    this.lastInput = inputvalue

    this.setState({
      ...this.state,
      formattedValue: formattedInputValue,
    })
  }

  handleBlur(inputvalue) {
    const { onChange } = this.props
    const isValidDateLieral = isValidDateLiteral(inputvalue)
    let date = null

    if (isValidDateLieral) {
      date = createDateFromMMDDYYYY(inputvalue)
    }
    onChange(date)
  }

  getDateFormat() {
    return 'MM-DD-YYYY'
  }

  render() {
    const { id, label, cmpRef, placeholder, style, help } = this.props
    const { formattedValue } = this.state

    return (
      <AInput
        id={id}
        label={label}
        cmpRef={cmpRef}
        prepender={this.getDateFormat()}
        onChange={(evt) => {
          this.handleChange(evt.target.value)
        }}
        onBlur={(evt) => {
          this.handleBlur(evt.target.value)
        }}
        type={'text'}
        value={formattedValue}
        placeholder={placeholder}
        maxLength={10}
        style={style}
        help={help}
      />
    )
  }

  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    cmpRef: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.instanceOf(Date),
    onChange: PropTypes.func.isRequired,
    style: PropTypes.string,
    help: PropTypes.string,
  }

  static defaultProps = { placeholder: '' }
}

export default ADateText
